/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import FindDeviceContent from "../FindDeviceContent/FindDeviceContent";

import Menu from "../../../../../Menu/Menu";

import { MenuAnchorEl } from "../../../../../../shared";

interface IDesktopFindDeviceProps {
  onClose: () => void;
  anchorEl: MenuAnchorEl;
}

const DesktopFindDevice = ({ onClose, anchorEl }: IDesktopFindDeviceProps) => {
  return (
    <Menu
      data-testid="desktop-find-device-dialog"
      disableRestoreFocus
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      css={css({
        "& .MuiPaper-root": {
          width: "566px",
        },
      })}
    >
      <FindDeviceContent close={onClose} />
    </Menu>
  );
};

export default DesktopFindDevice;
